const reboxingProduct = JSON.parse(
  document.querySelector("[data-reboxing-data]").textContent
);

const reboxingProduct10Id = reboxingProduct.variants.find((variant) =>
  variant.title.includes("$10")
).id;
const reboxingProduct35Id = reboxingProduct.variants.find((variant) =>
  variant.title.includes("$35")
).id;

const eventsToListen = [
  PUB_SUB_EVENTS.cartAdd,
  PUB_SUB_EVENTS.cartRemove,
  PUB_SUB_EVENTS.cartUpdate,
];

eventsToListen.forEach((event) => {
  document.addEventListener(event, async function (e) {
    const cart = await fetch(`/cart.js`).then((res) => res.json());
    if (!cart || !cart.items || (e.detail && e.detail.reboxIgnore)) return;

    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"]'
    );

    checkoutButtons.forEach((button) => {
      button.disabled = true;
    });

    let updates = {
      [reboxingProduct10Id]: 0,
      [reboxingProduct35Id]: 0,
    };

    cart.items.forEach((item) => {
      const properties = item.properties || {};

      if (properties["Re-boxing fee"] == "$10") {
        updates[reboxingProduct10Id]++;
      } else if (properties["Re-boxing fee"] == "$35") {
        updates[reboxingProduct35Id]++;
      }
    });

    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      }).then(() => {
        document.querySelector("cart-drawer").reload();
        // document.querySelector("cart-drawer").classList.add("is-empty");
      });
    } finally {
      checkoutButtons.forEach((button) => (button.disabled = false));
    }
  });
});

const variantId = document.querySelector(".product-variant-id")?.value;

document.addEventListener(PUB_SUB_EVENTS.variantChange, (e) =>
  updateReboxingVisuals(e.detail.variant.id)
);

if (variantId) {
  updateReboxingVisuals(variantId);
}

function updateReboxingVisuals(currentVariantId) {
  const reboxingProduct10 = document.querySelector(`[data-reboxing-fee="10"]`);
  const reboxingProduct35 = document.querySelector(`[data-reboxing-fee="35"]`);
  hideAll([reboxingProduct10, reboxingProduct35]);
  disableAllReboxingFees([reboxingProduct10, reboxingProduct35]);
  const variantSplicing = JSON.parse(
    document.querySelector(`[data-variant-splicing]`).textContent
  );
  const is35 = variantSplicing[currentVariantId] === "$35 Reboxing Fee";
  const is10 = variantSplicing[currentVariantId] === "$10 Reboxing Fee";
  if (is35) {
    show(reboxingProduct35);
    enableReboxingFees([reboxingProduct35]);
  } else if (is10) {
    show(reboxingProduct10);
    enableReboxingFees([reboxingProduct10]);
  }
}

function enableReboxingFees(els) {
  els.forEach((el) => {
    const input = el.querySelector("input");
    if (input) {
      input.disabled = false;
    }
  });
}

function show(el) {
  el.classList.remove("hidden");
}

function hide(el) {
  el.classList.add("hidden");
}

function hideAll(els) {
  els.forEach((el) => {
    el.classList.add("hidden");
  });
}

function disableAllReboxingFees(els) {
  els.forEach((el) => {
    const input = el.querySelector("input");
    if (input) {
      input.disabled = true;
    }
  });
}


function checkUrlForTabOpen() {
  setTimeout(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tabValue = urlParams.get('tab');
    if (!tabValue) return;
    const targetInput = document.querySelector(`input[data-tab-name="${tabValue}"]`);
    if (!targetInput) return;
    const headerOffset = 200;
    const elementPosition = targetInput.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    targetInput.click();
  }, 200);
}

checkUrlForTabOpen();